export const getDevice = () =>{
  const width = window.innerWidth;
  return width < 576 ? "xs" : width < 768 ? "sm" : width < 992 ? "md" : width < 1200 ? "lg" : "xl";
}
export const getDeviceRotation = () =>{
  if(window.innerWidth >= window.innerHeight)
    return "wide";
  else {
    return "narrow";
  }
}
const domain = window.location.protocol+"//"+window.location.hostname;
const endPoint = '/elocker-ctrl';
const loginEndPoint = '/elocker-ctrl';
export const SysPath = {
  domain: domain,
  getImgByPathUrl: domain + endPoint + '/webapi/locker/getImgByPath',
  getVideoByPathUrl: domain + endPoint + '/webapi/locker/getVideoByPath',
  addMatchRecordUrl: domain + endPoint + '/webapi/locker/addMatchRecord',
  addUnlockRecordUrl: domain + endPoint + '/webapi/locker/addUnlockRecord',
  addClearRecordUrl: domain + endPoint + '/webapi/locker/addClearRecord',
  addUnclearRecordUrl: domain + endPoint + '/webapi/locker/addUnclearRecord',
  addLabelUrl: domain + endPoint + '/webapi/locker/addLabel',
  roleUrl: domain + loginEndPoint + '/webapi/user/role',
  getLabelUrl: domain + endPoint + '/webapi/locker/getLabel',
  getLockerNumberUrl: domain + endPoint + '/webapi/locker/getLockerNumber',
  getUuidUrl: domain + endPoint + '/webapi/locker/getUUID',
  getByKeywordUrl: domain + endPoint + '/webapi/locker/getByKeyword',
  getMatchRecordsByKeywordUrl: domain + endPoint + '/webapi/locker/getMatchRecordsByKeyword',
  getPrintRecordsByKeywordUrl: domain + endPoint + '/webapi/locker/getPrintRecordsByKeyword',
  getUnlockRecordsUrl: domain + endPoint + '/webapi/locker/getUnlockRecordsByKeyword',
  getUnclearRecordsByKeywordUrl: domain + endPoint + '/webapi/locker/getUnclearRecordsByKeyword',
  getClearRecordsByKeywordUrl: domain + endPoint + '/webapi/locker/getClearRecordsByKeyword',
  getMismatchRecordsUrl: domain + endPoint + '/webapi/locker/getMismatchRecordsByKeyword',
  getLockerUrl: domain + endPoint + '/webapi/locker/get',
  logoutUrl: domain + loginEndPoint + '/webapi/auth/logout',
  addPrintRecordUrl: domain + endPoint + '/webapi/locker/addPrintRecord',
  polyuSignOutUrl: 'https://adfs.polyu.edu.hk/adfs/ls/?wa=wsignout1.0'
}
